import React, {Component} from 'react';

class Tooltip extends Component {
    replaceSubject(subject, replacements) {
        let text = subject;
        const replacementsKeys = Object.keys(replacements);

        if (replacementsKeys.length) {
            replacementsKeys.map((search) => {
                text = text.replace(`{${search}}`, replacements[search]);
            });
        }

        return text;
    }

    render() {
        const {
            subject,
            replacements = {},
            position = 'top',
            iconClassName = 'fa fa-info-circle',
            tabIndex = 0,
            addClass = '',
            children,
        } = this.props;

        const tooltipText = this.replaceSubject(subject, replacements);

        const tooltipConfig = {
            ...(tabIndex !== false && {tabIndex}),
            'data-tooltip-html': tooltipText,
            'data-tooltip-place': position,
        };

        const renderChildren = () => {
            return React.Children.map(children, (child) => {
                return React.cloneElement(child, tooltipConfig);
            });
        };

        return (
            <>
                {children ? (
                    renderChildren()
                ) : (
                    <span className={`tooltip-holder ${addClass}`}>
                        <i className={iconClassName} {...tooltipConfig} />
                    </span>
                )}
            </>
        );
    }
}

export default Tooltip;
